import { useLazyReadMonitorsQuery } from 'services/monitor/qmonitor'
import { useCreateSpyWithParams } from '../useCreateSpyWithParams'
import { compareArraysDeep } from 'shared/lib/compareArraysDeep'
import { CreateOrReadSpyParams } from './types'
import { getSpyLaunchMode } from 'shared/lib/getSpyLaunchMode'
import { filtersConvertFromApi } from 'shared/lib/filtersConvertFromApi'
import { deepEqual } from 'shared/lib/deepEqual'
import { spyLaunchSettingsConvertFromApiValue } from 'shared/lib/spyLaunchSettingsConvertFromApiValue'
import { isSameDay } from 'shared/lib/isSameDay'

const defaultSlidingPeriodsLength = 3

export const useCreateOrReadSpy = () => {
    const [createSpyWithParams] = useCreateSpyWithParams()
    const [readSpies] = useLazyReadMonitorsQuery()

    const createOrReadSpy = async (params: CreateOrReadSpyParams) => {
        const readSpiesResult = await readSpies(undefined)

        if (readSpiesResult.data === undefined || readSpiesResult.data.list === 0){
            const createSpyResult = await createSpyWithParams(params)
            return createSpyResult.data
        }

        const spiesWithSameLocation = []
        for (let i = 0; i < readSpiesResult.data.list.length; i++) {
            const currentSpy = readSpiesResult.data.list[i]
            const findByLocationResult = currentSpy.locations.find((spy: any) => spy.id === params.location.id)
            
            if (findByLocationResult === undefined){
                continue
            }

            spiesWithSameLocation.push(currentSpy)
        }

        const spiesWithSameLaunchSettings: any = []
        for (let i = 0; i < spiesWithSameLocation.length; i++){
            const currentSpy = spiesWithSameLocation[i]
            const spyLaunchMode = getSpyLaunchMode(currentSpy)
            const spyLaunchSettingsConverted = spyLaunchSettingsConvertFromApiValue(currentSpy)

            if (spyLaunchMode === 'sliding'){
                if (params.launchSettings !== undefined && params.launchSettings.mode === `sliding`){
                    if (params.launchSettings.params.daysAhead === currentSpy.slidingPeriods.length){
                        spiesWithSameLaunchSettings.push(currentSpy)
                        continue
                    }

                    continue
                }
            }            

            if (spyLaunchMode === 'custom'){
                if (params.launchSettings !== undefined && params.launchSettings.mode === 'custom'){
                    if (spyLaunchSettingsConverted?.params?.periods === undefined){
                        continue
                    }

                    const startIsSameDay = isSameDay(params.launchSettings.params.periods[0].startDate, spyLaunchSettingsConverted?.params?.periods[0].startDate)
                    const endIsSameDay = isSameDay(params.launchSettings.params.periods[0].endDate, spyLaunchSettingsConverted?.params?.periods[0].endDate)

                    if (startIsSameDay === true && endIsSameDay === true){
                        spiesWithSameLaunchSettings.push(currentSpy)
                    }

                    continue
                }
            }  
        }

        const spiesWithSameFilters = []
        for (let i = 0; i < spiesWithSameLaunchSettings.length; i++){
            const currentSpy = spiesWithSameLaunchSettings[i]
            const currentSpyFilters = filtersConvertFromApi(currentSpy)
            const equal = deepEqual(currentSpyFilters, params.filters)

            if (equal === true){
                spiesWithSameFilters.push(currentSpy)
            }
        }

        if (spiesWithSameFilters.length > 0){
            return spiesWithSameFilters[0]
        }

        const createSpyResult: any = await createSpyWithParams(params)
        return createSpyResult.data
    } 

  return {
      createOrReadSpy
  }
}